import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";

export default class CountdownMediator extends AbstractPopupMediator {

    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameConfig = gameConfig;
    }

    initialize() {
        super.initialize();
        this.anchorObject(this._target, Anchor.T);

        //this.playSound(SoundID.COUNTDOWN, null, null, 250);

        for (let i = 3; i >= 1; i--) {
            this.createTween(this._target["count" + i], (3 - i) * 1000);
        }
        this.onComplete = this.onComplete.bind(this);
        this.createGoTween(this._target.count0, 3000, this.onComplete);

        if (ranj.DEBUG) {
            this._clickEventType = AppModel.isTouch ? "touchend" : "click";
            document.body.addEventListener(this._clickEventType, this.onComplete);
        }
    }

    destroy() {
        super.destroy();
        document.body.removeEventListener(this._clickEventType, this.onComplete);
    }

    createTween(obj, delay) {
        obj.visible = false;
        obj.alpha = 1;
        obj.scaleX = obj.scaleY = .6;
        return createjs.Tween.get(obj)
            .wait(delay)
            .set({ visible: true })
            .to({ alpha: 1, scaleX: 1, scaleY: 1 }, 300, createjs.Ease.linear)
            .wait(200)
            .to({ alpha: 0 }, 300, createjs.Ease.linear)
            .wait(200);
    }

    createGoTween(obj, delay, onComplete) {
        obj.visible = false;
        obj.alpha = 1;
        obj.scaleX = obj.scaleY = .1;
        return createjs.Tween.get(obj)
            .wait(delay)
            .set({ visible: true })
            .to({ alpha: 1, scaleX: 1, scaleY: 1 }, 300, createjs.Ease.linear)
            .call(onComplete)
            .to({ alpha: 0, scaleX: 2, scaleY: 2 }, 300, createjs.Ease.linear);
    }

    onComplete() {
        let onClose = this._target.onClose;
        if (onClose != null) {
            onClose();
        }
        this._target.onClose = null;
        this.callDelayed(this.close.bind(this), 500);
    }
};
